__turbopack_context__.v({
  "alert": "index-module-scss-module__VVf7TG__alert",
  "close": "index-module-scss-module__VVf7TG__close",
  "float": "index-module-scss-module__VVf7TG__float",
  "full": "index-module-scss-module__VVf7TG__full",
  "icon": "index-module-scss-module__VVf7TG__icon",
  "notice": "index-module-scss-module__VVf7TG__notice",
  "round": "index-module-scss-module__VVf7TG__round",
  "show": "index-module-scss-module__VVf7TG__show",
  "success": "index-module-scss-module__VVf7TG__success",
  "warning": "index-module-scss-module__VVf7TG__warning",
});
